module.exports = __webpack_public_path__ + "img/white-arrow.e36365cc.svg";